// shell-init.js — SPA Shell 启动初始化
// 仅执行一次，路由切换时不重复
// 登录检查和 session 缓存写入已移至 ensureLogin 模块

export async function initShell() {
  // 关闭浏览器自带的滚动恢复
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
}
